import React from "react";
import Accordion from "../components/accordion/experiences";
import Subtitles from "../components/subtitles/subtitles";

const Experiences = () => {
  return (
    <>
      <Subtitles>Here is an overview of my professional experiences</Subtitles>
      <Accordion />
    </>
  );
};

export default Experiences;
